import React from "react";
import { Link } from "react-router-dom";
import { PageHero, SectionHeading } from "../components/Section";
import { Button } from "../components/ui/button";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { IMAGES } from "../data/mock";
import Seo from "../components/Seo";
import { FaqSection } from "../components/FaqSection";
import { AtAGlance } from "../components/AtAGlance";
import { faqData } from "../data/faqData";
import { Beaker, Wine, PenTool, Truck, ArrowRight } from "lucide-react";

const HowItWorks = () => {
  const { t, lang } = useApp();
  useReveal();

  const steps = [
    { icon: Beaker, title: t("home.step1"), desc: t("home.step1d"), img: IMAGES.tasting2 },
    { icon: Wine, title: t("home.step2"), desc: t("home.step2d"), img: IMAGES.pour2 },
    { icon: PenTool, title: t("home.step3"), desc: t("home.step3d"), img: IMAGES.label3 },
    { icon: Truck, title: t("home.step4"), desc: t("home.step4d"), img: IMAGES.cellar1 },
  ];

  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("how.title")} description={t("how.sub")} path="/how-it-works" />
      <PageHero title={t("how.title")} subtitle={t("how.sub")} image={IMAGES.tasting1} />
      <AtAGlance lang={lang} />
      <div className="max-w-6xl mx-auto px-6 py-20 space-y-20">
        {steps.map((s, i) => (
          <div key={i} className={`reveal grid md:grid-cols-2 gap-10 items-center ${i % 2 ? "md:[direction:rtl]" : ""}`}>
            <div className="rounded-3xl overflow-hidden shadow-xl [direction:ltr]">
              <img src={s.img} alt={s.title} className="w-full h-80 object-cover" />
            </div>
            <div className="[direction:ltr]">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-14 h-14 rounded-full bg-wine flex items-center justify-center border border-gold/40"><s.icon className="w-6 h-6 text-gold" /></div>
                <span className="font-serif text-5xl text-wine/20">0{i + 1}</span>
              </div>
              <h3 className="font-serif text-3xl text-ink">{s.title}</h3>
              <p className="mt-3 text-ink/65 text-lg leading-relaxed">{s.desc}</p>
            </div>
          </div>
        ))}
      </div>
      <section className="bg-ink py-20">
        <div className="max-w-3xl mx-auto px-6 text-center reveal">
          <h2 className="font-serif text-3xl md:text-4xl text-cream">{t("how.orderTitle")}</h2>
          <p className="mt-4 text-cream/70 text-lg">{t("how.orderDesc")}</p>
          <Link to="/wine-configurator"><Button className="mt-8 bg-wine hover:bg-wine-light text-white h-13 px-9 rounded-full gap-2 h-12">{t("common.blendNow")} <ArrowRight className="w-5 h-5" /></Button></Link>
        </div>
      </section>
      <FaqSection faqs={faqData.how[lang] || faqData.how.de} lang={lang} />
    </div>
  );
};

export default HowItWorks;
